import React from 'react';
import logo from './logo_full_color_no_tag.png';
import { Link } from 'react-router-dom';
import css from './TopbarScanwow.module.css';
import CategoriesMenu from './CategoriesMenu';
import PersonIcon from '@mui/icons-material/Person';
import { useHistory } from 'react-router-dom';
import { ProfileMenu } from '../TopbarDesktop/TopbarDesktop';

const TopbarScanwow = ({ currentUser, currentPage, onLogout }) => {
  const authText = !currentUser && 'Login';
  const history = useHistory();
  const isAuthenticated = !!currentUser;
  return (
    <div className={css.wrapper}>
      <div className={css.content}>
        <Link to="/">
          <img src={logo} alt="Scanwow Logo" className={css.logo} />
        </Link>

        <div className={css.menuWrapper}>
          <CategoriesMenu />
          {isAuthenticated ? (
            <ProfileMenu currentPage={currentPage} currentUser={currentUser} onLogout={onLogout} />
          ) : (
            <div className={css.authButton} onClick={() => history.push('/login')}>
              {authText && <p className={css.loginText}>{authText} </p>}
              <PersonIcon className={css.avatar} fontSize={'medium'} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TopbarScanwow;
